/**
 * Re-exported from @wrongstack/core. This file exists for backward
 * compatibility — tools/src/bash.ts and exec.ts import './_env.js'.
 */
export { buildChildEnv } from '@wrongstack/core';
